import { render, staticRenderFns } from "./GBRightPaneProjectInfo.vue?vue&type=template&id=1067d47d&"
import script from "./GBRightPaneProjectInfo.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneProjectInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VForm,VIcon,VLayout,VTextField,VTextarea})
